export default __webpack_public_path__ + "static/media/text-snippet.6c12abe4.svg";